"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_1 = __importDefault(require("react"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n"], ["\n    display: flex;\n    align-items: center;\n"])));
var Flag = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, country = _a.country, className = _a.className;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement("img", { 
            // eslint-disable-next-line global-require, import/no-dynamic-require
            src: require("../../images/flags/" + country.toLowerCase() + ".svg"), width: size + "px", alt: "flag-" + country, className: className })));
};
exports.Flag = Flag;
var templateObject_1;
